<template>
    <span :class="textClass">{{ row.KumilatifBakiyeStr || '-' }}</span>
</template>

<script>
export default {
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{
        textClass(){
            if(this.row.KumilatifBakiye > 0) return 'text-primary font-weight-bolder'
            else if(this.row.KumilatifBakiye < 0) return 'text-warning font-weight-bolder'
            else return null
        }
    }
}
</script>